// extracted by css-extract-rspack-plugin
export default {"note":"ShelfNote-module__note___ZlF3w"};